<template>
  <!-- 同意書情報入力画面 -->
  <div id="AppPatientManagementEditConsentForm">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <div class="box" style="margin-left: 50px; margin-right: 50px;">
      <div class="columns">
        <div class="column">
          <label class="searchTitle label">ANPY同意書情報入力画面（患者入力欄）</label>
        </div>
      </div>
      <!-- 同意書入力画面（患者入力欄） -->
      <template v-if="isCreated">
        <font size="6">個人情報の取扱いに関する同意書</font>
        <div style="text-align:left">
          <br />
          <br />株式会社フィリップス・ジャパンは、当社が定める「お客様の個人情報の取り扱いについての当社の方針」に則り、
          <br />個人情報を適切に利用いたします。
          <br />https://www.philips.co.jp/a-w/about-philips/company-profile/local-personal-information.html
          <br />
          <br />【個人情報の利用目的】
          <br />ANPY をご利用いただくにあたりお客様からご提供いただいた個人情報を次の目的に利用します。
          <br />• 災害時に必要な器材・用品の適切な供給体制を整えるため
          <br />• 停電その他の情報を配信するため（ご希望の方のみ）
          <br />• 株式会社フィリップス・ジャパンが取り扱う製品やサービスの販売促進および提供のため
          <br />【取得・利用する情報】
          <br />• 指示書に記載されている氏名、住所、電話番号、使用器機等の情報
          <br />• お客様のご家庭の通電状況
          <br />• GPS 機能によるANPY 機器の位置情報
          <br />• 以下に記載いただく情報
        </div>
        <br />
        <br />
      </template>
      <table class="table is-full">
        <table style="width: 100%;">
          <tr v-for="(item, index) in data.tels" v-bind:key="index">
            <th
              style="border-bottom: solid 1px; border-top: solid 1px;"
              rowspan="10"
              v-if="index==0"
            >
              ANPY緊急連絡先
              <b-button
                v-if="roleId!=2"
                style="float:right; margin-left:10px;"
                class="button is-primary has-text-centered"
                icon-left="account-plus"
                native-type="button"
                v-on:click="addTels()"
              ></b-button>
            </th>
            <td style="border-bottom: solid 1px; border-top: solid 1px;">
              <b-field
                :type="{'is-danger':errors.has(getFieldName('emergencyContactlList',index))}"
                :message="errors.first(getFieldName('emergencyContactlList',index))"
              >
                <b-select
                  v-model="item.emergencyContactlList"
                  :name="getFieldName('emergencyContactlList',index)"
                  :input="inputValue(item.emergencyContactlList,index)"
                  data-vv-as="続柄"
                  data-vv-validate-on="input"
                  v-validate="`${item.emergencyContactPhoneNumber|item.selfArrow!=null&item.selfArrow!=''?'required':''}`"
                >
                  <option value :disabled="roleId==2"></option>
                  <option value="本人" :disabled="roleId==2">本人</option>
                  <option value="家族" :disabled="roleId==2">家族</option>
                  <option value="知人" :disabled="roleId==2">知人</option>
                  <option value="訪問看護" :disabled="roleId==2">訪問看護</option>
                  <option value="医師" :disabled="roleId==2">医師</option>
                  <option value="ME" :disabled="roleId==2">ME</option>
                  <option value="その他" :disabled="roleId==2">その他</option>
                </b-select>
              </b-field>
            </td>
            <td style="border-bottom: solid 1px; border-top: solid 1px;">
              <b-field
                :type="{'is-danger':errors.has(getFieldName('emergencyContactFree',index))}"
                :message="errors.first(getFieldName('emergencyContactFree',index))"
              >
                <b-input
                  v-model="item.emergencyContactFree"
                  :name="getFieldName('emergencyContactFree',index)"
                  data-vv-as="続柄(フリー)"
                  placeholder="「続柄：その他」選択時のフリー項目"
                  data-vv-validate-on="input"
                  v-validate="`${item.emergencyContactlList=='その他'?'required':''}|max:20`"
                  :readonly="roleId==2 || item.emergencyContactlList!='その他'"
                ></b-input>
              </b-field>
            </td>
            <td style="border-bottom: solid 1px; border-top: solid 1px;">
              <b-field
                :type="{'is-danger':errors.has(getFieldName('emergencyContactPhoneNumber',index))}"
                :message="errors.first(getFieldName('emergencyContactPhoneNumber',index))"
              >
                <b-input
                  v-model="item.emergencyContactPhoneNumber"
                  :name="getFieldName('emergencyContactPhoneNumber',index)"
                  placeholder="携帯番号"
                  data-vv-as="緊急連絡先"
                  :readonly="roleId==2"
                  data-vv-validate-on="input"
                  v-validate="`${item.emergencyContactlList!=null&item.emergencyContactlList!=''|item.selfArrow!=null&item.selfArrow!=''?'required':''}|max:20`"
                ></b-input>
              </b-field>
            </td>
            <th style="border-bottom: solid 1px; border-top: solid 1px; width:150px;">停電情報の配信希望</th>
            <td style="border-bottom: solid 1px; border-top: solid 1px;">
              <b-field
                :type="{'is-danger':errors.has(getFieldName('selfArrow',index))}"
                :message="errors.first(getFieldName('selfArrow',index))"
              >
                <b-select
                  v-model="item.selfArrow"
                  :name="getFieldName('selfArrow',index)"
                  data-vv-as="連絡可否"
                  data-vv-validate-on="input"
                  v-validate="`${item.emergencyContactPhoneNumber|item.emergencyContactlList!=null&item.emergencyContactlList!=''?'required':''}`"
                >
                  <option value :disabled="roleId==2"></option>
                  <option value="0" :disabled="roleId==2">希望</option>
                  <option value="1" :disabled="roleId==2">希望しない</option>
                </b-select>
              </b-field>
            </td>
            <td style="border-bottom: solid 1px; border-top: solid 1px;">
              <b-button
                v-if="index > 4"
                style="float:right; margin-left:10px;"
                class="button is-primary has-text-centered"
                icon-left="account-minus"
                native-type="button"
                v-on:click="data.tels.splice(index, 1)"
              ></b-button>
            </td>
          </tr>
        </table>
      </table>
      <div v-if="isCreated" style="text-align:left">
        【免責事項】
        <br />本製品は、通電状況・位置情報をモニタリングすることを目的としており、災害時のサポートを保証する
        <br />ものではありません。
        <br />
        <br />
        <br />以上の内容をお読みの上ご同意を頂ける場合は、本書にご署名をお願い申し上げます。
        <br />
        <br />
      </div>
      <div></div>
      <b-field
        v-if="isCreated"
        :type="{'is-danger':errors.has('signature')}"
        :message="errors.first('signature')"
      >
        <b-button
          style="float:left; width:300px;"
          class="button is-primary has-text-centered"
          icon-left="pen"
          native-type="button"
          v-on:click="inputSign()"
        >サイン</b-button>
        <b-modal :active.sync="isComponentModalActive" has-modal-card full-screen>
          <sign-modal v-on:set-data="setSignData"></sign-modal>
        </b-modal>
        <img id="sign" style="margin-left:5px;border:5px solid #ccc;width:40%" />
      </b-field>
      <div
        v-if="data.alternativeWriting&&isCreated"
        style="text-align:left;margin-left:300px;"
      >代筆理由：{{data.alternativeWritingReason}}</div>
      <div v-if="!isCreated" style="text-align:left;margin-left:1%;width:70%">
        <th style="width:20%">同意書取得日：</th>
        <td style="padding-left:2%;text-align:left;">{{getConsentCreateAt(data.signature)}}</td>
      </div>
    </div>
    <!-- 同意書情報入力画面（事務処理欄） -->
    <div style="clear:both;"></div>
    <div style="height: 10px;" />
    <div class="box" style="margin-left: 50px; margin-right: 50px; ">
      <div class="columns">
        <div class="column">
          <label class="searchTitle label">ANPY同意書情報入力画面（事務処理欄）</label>
        </div>
      </div>
      <div style="detailArea">
        <div>
          <table class="table is-full">
            <table style="width: 100%;">
              <tr>
                <th style="border-bottom: solid 1px; width: 150px;">患者コード</th>
                <td style="border-bottom: solid 1px;" colspan="5">
                  <b-field
                    :type="{'is-danger':errors.has('recipientCode')}"
                    :message="errors.first('recipientCode')"
                  >
                    <b-input
                      v-model="data.recipientCode"
                      :readonly="true"
                      data-vv-as="患者コード"
                      name="recipientCode"
                      style="width: 100%;"
                    ></b-input>
                    <b-button
                      v-if="checkTemporaryRecipientCode(false)"
                      :disabled="data.anpyFlag"
                      style="float:right; bottom:0;"
                      class="button is-primary has-text-centered"
                      icon-left="account"
                      native-type="button"
                      v-on:click="changePatient"
                    ></b-button>
                    <b-input
                      v-if="!isTemporaryRecipientCode"
                      v-model="data.recipientName"
                      :readonly="true"
                      data-vv-as="患者名"
                      name="recipientName"
                      style="width: 100%;"
                    ></b-input>
                    <b-input
                      v-if="isTemporaryRecipientCode"
                      v-model="data.recipientName"
                      :readonly="true"
                      placeholder="仮患者コード"
                      data-vv-as="患者名"
                      name="recipientName"
                      style="width: 100%;"
                    ></b-input>
                    <b-button
                      v-if="roleId != 2"
                      :disabled="!data.recipientCode || data.anpyFlag"
                      style="float:right; bottom:0;"
                      class="button is-primary has-text-centered"
                      native-type="button"
                      v-on:click="clearRecipient()"
                    >クリア</b-button>
                  </b-field>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px; width: 150px;">患者名メモ</th>
                <td style="border-bottom: solid 1px;" colspan="5">
                  <b-field
                    :type="{'is-danger':errors.has('recipientNameMemo')}"
                    :message="errors.first('recipientNameMemo')"
                  >
                    <b-input
                      :readonly="roleId==2"
                      v-model="data.recipientNameMemo"
                      name="recipientNameMemo"
                      data-vv-as="患者名メモ"
                      data-vv-validate-on="input"
                      v-validate="`${data.recipientCode?'':'required'}|max:150`"
                    ></b-input>
                  </b-field>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">ANPY設置担当者</th>
                <td style="border-bottom: solid 1px;" colspan="5">{{data.staffName}}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">ANPY設置担当者営業所</th>
                <td style="border-bottom: solid 1px;" colspan="5">{{data.officeName}}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">越境依頼元営業所</th>
                <td style="border-bottom: solid 1px;" colspan="5">
                  <b-field
                    :type="{'is-danger':errors.has('senderSalesOfficeCode')}"
                    :message="errors.first('senderSalesOfficeCode')"
                  >
                    <b-select
                      expanded
                      name="senderSalesOfficeCode"
                      v-model="data.senderSalesOfficeCode"
                      data-vv-as="越境依頼元営業所"
                      data-vv-validate-on="input"
                      v-validate="'required'"
                    >
                      <option
                        v-for="office in officeMaster"
                        :value="office.officeCode"
                        :key="office.officeCode"
                      >{{ office.officeName }}</option>
                    </b-select>
                  </b-field>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">ANPY連係営業所</th>
                <td
                  style="border-bottom: solid 1px;"
                  colspan="5"
                >{{getOfficeName(data.salesOfficeCode,officeMaster)}}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;" rowspan="2">ANPY機器情報</th>
                <th style="border-bottom: solid 1px; width:100px;">品目名</th>
                <td style="border-bottom: solid 1px;" colspan="4">
                  <b-field
                    :type="{'is-danger':errors.has('itemCode')}"
                    :message="errors.first('itemCode')"
                  >
                    {{data.itemCode|productNameFilter(productMaster)}}
                    <template
                      v-if="data.itemCode"
                    >({{data.itemCode}})</template>
                    <b-button
                      v-if="roleId!=2"
                      style="float:right; margin-left:10px;"
                      class="button is-primary has-text-centered"
                      icon-left="camera"
                      native-type="button"
                      v-on:click="scan(data.itemCode,data.serial,0)"
                    ></b-button>
                  </b-field>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px; width:100px;">シリアルNo.</th>
                <td style="border-bottom: solid 1px;" colspan="4">{{data.serial}}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;" rowspan="2">バッテリー情報</th>
                <th style="border-bottom: solid 1px; width:100px;">品目名</th>
                <td style="border-bottom: solid 1px;" colspan="4">
                  <b-field
                    :type="{'is-danger':errors.has('butterryItemCode')}"
                    :message="errors.first('butterryItemCode')"
                  >
                    {{data.butterryItemCode|productNameFilter(productMaster)}}
                    <template
                      v-if="data.butterryItemCode"
                    >({{data.butterryItemCode}})</template>
                    <b-button
                      v-if="roleId!=2"
                      style="float:right; margin-left:10px;"
                      class="button is-primary has-text-centered"
                      icon-left="camera"
                      native-type="button"
                      v-on:click="scan(data.butterryItemCode,data.butterrySerial,1)"
                    ></b-button>
                  </b-field>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px; width:100px;">シリアルNo.</th>
                <td style="border-bottom: solid 1px;" colspan="4">{{data.butterrySerial}}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">ANPY緊急連絡レベル</th>
                <td style="border-bottom: solid 1px;" colspan="5">
                  <b-field
                    :type="{'is-danger':errors.has('emergencyLevel')}"
                    :message="errors.first('emergencyLevel')"
                  >
                    <b-select
                      expanded
                      v-model="data.emergencyLevel"
                      name="emergencyLevel"
                      data-vv-as="ANPY緊急連絡レベル"
                      data-vv-validate-on="input"
                      v-validate="'required'"
                    >
                      <option value="1" :disabled="roleId==2">S : NPPV 24h（マスク）</option>
                      <option value="2" :disabled="roleId==2">A : TPPV 24h（気切）</option>
                      <option value="3" :disabled="roleId==2">B : TPPV 夜間のみ（気切）</option>
                      <option value="4" :disabled="roleId==2">C : NPPV 夜間のみ（マスク）</option>
                      <option value="5" :disabled="roleId==2">D：HOT24h（設定値３L以上）</option>
                      <option value="6" :disabled="roleId==2">E：HOT24h（設定値３L未満）</option>
                    </b-select>
                  </b-field>
                </td>
              </tr>
            </table>
          </table>
          <b-modal :active.sync="isSupportStaffChangeActive" has-modal-card>
            <staffChange-modal v-on:staff-change-event="staffChanged" v-bind:item="null"></staffChange-modal>
          </b-modal>
          <b-modal :active.sync="isSelectPatientActive" has-modal-card full-screen>
            <selectPatient-form v-on:set-patient="setPatientInfo"></selectPatient-form>
          </b-modal>
          <b-modal :active.sync="isSerialPuroductReaderModalActive" has-modal-card full-screen>
            <serialProductReader-modal
              v-bind:itemcode="scanItemCode"
              v-bind:serial="scanSerial"
              v-bind:type="scanType"
              v-on:serial-input-event="serialChanged"
            ></serialProductReader-modal>
          </b-modal>
        </div>
      </div>
    </div>
    <!-- 下部余白 -->
    <div style="height: 50px;" />
    <div class="columns">
      <div class="column is-full" style="text-align:center;">
        <b-button
          v-on:click="back"
          class="button"
          type="is-primary"
          icon-left="keyboard-backspace"
          native-type="button"
        >戻る</b-button>
        <b-button
          v-if="roleId != 2"
          v-on:click="save"
          class="button"
          type="is-primary"
          icon-left="content-save"
          native-type="button"
        >登録</b-button>
        <b-button
          v-if="roleId == 1 && checkTemporaryRecipientCode(true)"
          v-on:click="deleteData"
          class="button"
          type="is-primary"
          icon-left="cancel"
          native-type="button"
        >削除</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import SelectPatientTemplate from "./AppPatientSearch";
import StaffSearchTemplate from "./AppSelectStaff";
var canvas;
var ctx;
var moveflg = 0;
var Xpoint = 0;
var Ypoint = 0;
var signFlg = false;
// 初期値（サイズ、色、アルファ値）の決定
var defSize = 5;
var defColor = "#555";
var cnt = 0;

// ネイティブアプリとやりとりするためのPromise
window.nativePromises = {};
function generateUUID() {
  var d = new Date().getTime();
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
    c
  ) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}
window.resolvePromise = function(promiseId, data, error) {
  if (error) {
    window.nativePromises[promiseId].reject(data);
  } else {
    window.nativePromises[promiseId].resolve(data);
  }
  // remove referenfe to stored promise
  delete window.nativePromises[promiseId];
};

const SelectPatientForm = {
  methods: {
    select: function() {
      var item = this.$refs.selectedPatient.getSelectedItem();
      var flg = false;
      // 選択結果を画面に反映
      if (item) {
        var roleId = JSON.parse(sessionStorage.getItem("userInfo")).roleId;
        if (roleId != 1 && roleId != 2) {
          var selectOfficeCodes = item.officeCode.split(",");
          var officeCode = JSON.parse(sessionStorage.getItem("userInfo"))
            .officeCode;
          var officeCodes = JSON.parse(sessionStorage.getItem("userInfo"))
            .referenceOfficeCodes;
          for (var i = 0; i < selectOfficeCodes.length; i++) {
            if (selectOfficeCodes[i] == officeCode) {
              flg = true;
              break;
            }
            for (var j = 0; j < officeCodes.length; j++) {
              if (selectOfficeCodes[i] == officeCodes[j]) {
                flg = true;
                break;
              }
            }
          }
          if (flg) {
            this.$emit("set-patient", item);
            this.$parent.close();
          } else {
            this.showErrorMessage(
              "自身の所属する営業所 もしくは 参照可能である営業所<br>に紐付く情報を選択してください"
            );
          }
        } else {
          this.$emit("set-patient", item);
          this.$parent.close();
        }
      } else {
        this.showErrorMessage("患者情報を選択してください");
      }
    }
  },
  components: {
    selectPatient: SelectPatientTemplate
  },
  template: `
  　<form style="width: 90%;height:30px;margin-left: 5%;margin-top: 1%;">
      <div class="modal-card" style="width: 100%;">
        <section class="modal-card-body" style="width: 100%;height:100%;">
          <selectPatient ref="selectedPatient" v-bind:select-mode="true" v-bind:is-nationwide-search="false" :multiSelectMode="false"/>
          <div style="height: 10px;" />
        </section>
        <footer style="text-align:center;">
          <b-button
           v-on:click=$parent.close()
           class="button"
           type="is-primary"
           icon-left="keyboard-backspace"
           native-type="button"
          >戻る</b-button>
          <b-button                       
           v-on:click="select"
           class="button"
           type="is-primary"
           icon-left="content-save"
           native-type="button"
          >選択</b-button>
          <div style="height: 10px;" />
        </footer>
      </div>
    </form>
`
};
const ModalForm = {
  props: ["item"],
  components: {
    staffSearch: StaffSearchTemplate
  },
  methods: {
    save: function(event) {
      // 選択されている担当者を取得
      var staffInfo = this.$refs.staffList.getStaff();
      this.officeCode = staffInfo.officeCode;
      this.officeName = staffInfo.officeName;
      this.staffId = staffInfo.id;
      this.staffName = staffInfo.lastName + staffInfo.firstName;
      this.setStaffs(
        this.officeCode,
        this.officeName,
        this.staffId,
        this.staffName
      );
    },
    setStaffs: function(officeCode, officeName, staffId, staffName) {
      // 選択された担当者情報を親画面に返却
      this.$emit(
        "staff-change-event",
        officeCode,
        officeName,
        staffId,
        staffName,
        this.$props.item
      );
      this.$parent.close();
    }
  },
  data() {
    return {
      officeMasterList: JSON.parse(sessionStorage.getItem("officeMaster"))
    };
  },
  template: `
        <form action="">
          <div class="modal-card" style="width: 800px;">
            <header class="modal-card-head">
                <p class="modal-card-title" style="color: whitesmoke;">担当者変更</p>
            </header>
            <section class="modal-card-body">
              <staffSearch ref="staffList" v-on:set-staff-event="setStaffs" v-bind:office-master-list="officeMasterList"/>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="save">決定</button>
                <button class="button" type="button" @click="$parent.close()">閉じる</button>
            </footer>
          </div>
        </form>
      `
};
const SignTemplate = {
  props: ["sign", "perProcuration"],
  data() {
    var alternativeWritingReason = "";
    var checkConsent = false;
    var reason = false;
    return {
      alternativeWritingReason,
      checkConsent,
      reason
    };
  },
  methods: {
    signUp: function(event) {
      this.$validator.validateAll().then(validatorResult => {
        if (validatorResult) {
          // 署名をイメージに変換
          var signData = document.getElementById("signCanvas").toDataURL();
          signData = signData.replace("data:image/png;base64,", "");
          // サインチェック
          if (ctx.strokeStyle == "#555555") {
            // 代理サインフラグ
            var signFlg = this.checkConsent;
            // 代理サイン理由
            var signReason = this.alternativeWritingReason;
            if (
              (!signFlg && signReason == "") ||
              (signFlg && signReason != "")
            ) {
              this.$emit("set-data", signData, signFlg, signReason);
              // 署名モーダル閉じる
              this.$parent.close();
            } else {
              // エラーメッセージ表示
              this.showErrorMessage("代筆サインまたは、代筆理由が未入力です。");
            }
          } else {
            // エラーメッセージ表示
            this.showErrorMessage("署名が未入力です。");
          }
        }
      });
    },
    clearCanvas: function(event) {
      ctx.clearRect(
        0,
        0,
        ctx.canvas.clientWidth + 10,
        ctx.canvas.clientHeight + 10
      );
      ctx.strokeStyle = "#000000";
      // フォーカスを外す
      var active_element = document.activeElement;
      if (active_element) {
        active_element.blur();
      }
    },
    startPoint: function(e) {
      e.preventDefault();
      ctx.beginPath();
      if (!e.offsetX) {
        Xpoint = e.touches[0].pageX - e.touches[0].target.offsetLeft;
      } else {
        Xpoint = e.offsetX;
      }
      if (!e.offsetY) {
        Ypoint = e.touches[0].pageY - e.touches[0].target.offsetTop;
      } else {
        Ypoint = e.offsetY;
      }
      ctx.moveTo(Xpoint, Ypoint);
    },
    movePoint: function(e) {
      if (e.buttons === 1 || e.witch === 1 || e.type === "touchmove") {
        if (!e.offsetX) {
          Xpoint = e.touches[0].pageX - e.touches[0].target.offsetLeft;
        } else {
          Xpoint = e.offsetX;
        }
        if (!e.offsetY) {
          Ypoint = e.touches[0].pageY - e.touches[0].target.offsetTop;
        } else {
          Ypoint = e.offsetY;
        }
        moveflg = 1;
        ctx.lineTo(Xpoint, Ypoint);
        ctx.lineCap = "round";
        ctx.lineWidth = defSize * 2;
        ctx.strokeStyle = defColor;
        ctx.stroke();
      }
    },
    endPoint: function(e) {
      if (moveflg === 0) {
        ctx.lineTo(Xpoint - 1, Ypoint - 1);
        ctx.lineCap = "round";
        ctx.lineWidth = defSize * 2;
        ctx.strokeStyle = defColor;
        ctx.stroke();
      }
      moveflg = 0;
    },
    inputReason() {
      if (!this.checkConsent) {
        this.alternativeWritingReason =
          "本人、ご家族の許可を得て代理サインしております。";
      } else {
        this.alternativeWritingReason = "";
      }
    }
  },
  mounted() {
    canvas = document.getElementById("signCanvas");
    canvas.width = divCanvas.clientWidth;
    canvas.height = divCanvas.clientHeight;
    ctx = canvas.getContext("2d");
    // PC対応
    canvas.addEventListener("mousedown", this.startPoint, false);
    canvas.addEventListener("mousemove", this.movePoint, false);
    canvas.addEventListener("mouseup", this.endPoint, false);
    // スマホ対応
    canvas.addEventListener("touchstart", this.startPoint, false);
    canvas.addEventListener("touchmove", this.movePoint, false);
    canvas.addEventListener("touchend", this.endPoint, false);
  },
  template: `
        <div>
            <div class="modal-card" style="width: 100%;">
                <header class="modal-card-head">
                    <p class="modal-card-title" style="color: whitesmoke; text-align: left">署名</p>
                </header>
                <section class="modal-card-body" style="width: 100%;">
                  <div align="center" id="divCanvas" class="columns" style="width: 98%;height: 500px;">
                    <canvas class="is-full"
                      id="signCanvas"
                      style="border:5px solid #ccc;">
                    </canvas>
                  </div>
                  <div class="columns" style="text-align: left;">
                    <div class="column is-full">
                      <b-checkbox
                      v-model="checkConsent"
                      @click.native="inputReason()"
                      style="font-size: 16px; font-weight: bold">代理サイン</b-checkbox>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column" style="text-align: left;">
                      <span style="font-size: 16px; font-weight: bold;">代理サイン理由</span>
                      <b-field
                        :type="{'is-danger':errors.has('alternativeWritingReason')}"
                        :message="errors.first('alternativeWritingReason')"
                      >
                        <b-input
                          v-model="alternativeWritingReason"
                          name="alternativeWritingReason"
                          data-vv-as="代筆理由"
                          v-validate="'max:50'"
                          maxlength="50" />
                      </b-field>
                    </div>
                  </div>
                </section>
                <footer class="modal-card-foot">
                    <b-button class="button" type="button" @click="signUp()">登録する</b-button>
                    <b-button class="button" type="button" @click="clearCanvas()">クリア</b-button>
                </footer>
            </div>
        </div>
      `
};
const serialProductScannerTemplate = {
  props: ["itemcode", "serial", "type"],
  data() {
    return {
      productCode: "",
      serialCode: ""
    };
  },
  methods: {
    cancel() {
      this.$parent.close();
    },
    childFunction() {
      if (this.productCode && this.serialCode) {
        if (this.serialCode.length > 18) {
          this.showErrorMessage(
            "19文字以上の「シリアル番号」は登録出来ません。"
          );
          return;
        }
        this.itemcode = this.productCode;
        this.serial = this.serialCode;
        //選択された点検種別を親画面に返却
        this.$emit(
          "serial-input-event",
          this.productCode,
          this.serialCode,
          this.type
        );
        this.$parent.close();
      } else {
        this.showErrorMessage("未入力の項目があります。");
      }
    }
  },
  component: {},
  template: `
    <form action="">
      <div class="modal-card" style="width: 1280px; height: 800px;">
        <header class="modal-card-head">
            <p class="modal-card-title" style="color: whitesmoke; text-align: left">交換機器</p>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column is-one-seconds">
              <b-field label="品目コード" horizontal>
                <b-input                
                placeholder="品目コードを入力してください。"
                v-model="productCode"
                ></b-input>
              </b-field>
            </div>
            <div class="column is-one-seconds">
              <b-field label="シリアルNo." horizontal>
                <b-input                
                placeholder="シリアルナンバーを入力してください。"
                v-model="serialCode"
                ></b-input>
              </b-field>
            </div>
          </div>
          <div style="width: 1240px; height: 550px;"/>
        </section>
        <footer class="modal-card-foot">
          <b-button class="button" type="button" v-on:click="cancel()">戻る</b-button>
          <b-button class="button" type="button" v-on:click="childFunction()">決定</b-button>
        </footer>
      </div>
    </form>
    `
};
export default {
  name: "AppPatientManagementEditConsentForm",
  methods: {
    checkTemporaryRecipientCode(isDelete) {
      if (this.roleId == 2) return false;

      // 仮患者コード判定
      if (this.isCreated) {
        // 登録画面
        if (!isDelete) {
          // 患者選択ボタンは常に表示
          return true;
        }
      } else {
        // 編集画面
        if (!isDelete) {
          return true;
        }
        if (this.isTemporaryRecipientCode) {
          // 仮患者コードの場合のみ削除ボタン表示
          return true;
        }
      }
      return false;
    },
    inputSign() {
      this.isComponentModalActive = true;
      // 画面トップにスクロール
      scrollTo(0, 0);
    },
    setSignData: function(signData, signFlg, reason) {
      // 署名関連データの設定
      this.data.signature = signData; //署名データ
      this.data.alternativeWriting = signFlg; //代筆フラグ
      this.data.alternativeWritingReason = reason; //代筆理由
      // エラー解除
      this.$validator.errors.remove("signature");
      // サインイメージを描画
      document.getElementById("sign").src = "data:image/png;base64," + signData;
    },
    changePatient: function(value) {
      this.isSelectPatientActive = true;
    },
    setPatientInfo: function(item) {
      // 患者選択結果設定
      this.data.recipientCode = item.patientCode;
      this.data.recipientName = item.patientName;
      this.recipientOfficeCodes = item.officeCode.split(",");
      this.consentFormDeleteTarget = item.consentFormDeleteTarget;
    },
    changeStaff: function(event) {
      this.isSupportStaffChangeActive = true;
    },
    staffChanged: function(officeCode, officeName, staffId, staffName, info) {
      // 担当者変更結果設定
      this.data.staffId = staffId;
      this.data.staffName = staffName;
      this.data.officeCode = officeCode;
      this.data.officeName = officeName;
    },
    save: function(event) {
      // 登録処理
      var productFlg = true;
      var butterryFlg = true;
      var signatureFlg = true;

      if (this.isCreated) {
        // 同意書入力画面のみ
        // サインの必須チェック
        if (
          typeof this.data.signature != "string" ||
          this.data.signature == ""
        ) {
          this.$validator.errors.add({
            field: "signature",
            msg: "サインは必須項目です。"
          });
          signatureFlg = false;
        } else {
          this.$validator.errors.remove("signature");
        }
      }

      // ANPY機器(本体)品目コードの必須チェック
      if (!this.data.itemCode) {
        this.$validator.errors.add({
          field: "itemCode",
          msg: "ANPY機器(本体)は必須項目です。"
        });
        productFlg = false;
      } else {
        this.$validator.errors.remove("itemCode");
      }

      // ANPY機器(本体)品目コードの必須チェック
      if (!this.data.butterryItemCode) {
        this.$validator.errors.add({
          field: "butterryItemCode",
          msg: "ANPY機器(バッテリ)は必須項目です。"
        });
        butterryFlg = false;
      } else {
        this.$validator.errors.remove("butterryItemCode");
      }

      this.$validator.validateAll().then(result => {
        if (result && productFlg && butterryFlg && signatureFlg) {
          if (this.consentFormDeleteTarget) {
            this.deleteRecipientConfirm();
          } else {
            var excuteApi = this.setEnterConsentInfoPOST;
            var successCallBack = this.setEnterConsentInfoPOSTSuccess;
            var errorCallBack = this.setEnterConsentInfoPOSTError;
            this.apiCall(excuteApi, successCallBack, errorCallBack);
          }
        } else {
          scrollTo(0, 0);
        }
      });
    },
    setEnterConsentInfoPOST: function(client) {
      var setData = {
        id: this.id,
        recipientCode: this.data.recipientCode ? this.data.recipientCode : "",
        recipientName: this.data.recipientName ? this.data.recipientName : "",
        recipientNameMemo: this.data.recipientNameMemo
          ? this.data.recipientNameMemo
          : "",
        staffId: this.data.staffId ? this.data.staffId : null,
        staffName: this.data.staffName ? this.data.staffName : "",
        officeCode: this.data.officeCode ? this.data.officeCode : "",
        officeName: this.data.officeName ? this.data.officeName : "",
        salesOfficeCode: this.data.salesOfficeCode
          ? this.data.salesOfficeCode
          : "",
        senderSalesOfficeCode: this.data.senderSalesOfficeCode
          ? this.data.senderSalesOfficeCode
          : "",
        itemCode: this.data.itemCode ? this.data.itemCode : "",
        serial: this.data.serial ? this.data.serial : "",
        butterryItemCode: this.data.butterryItemCode
          ? this.data.butterryItemCode
          : "",
        butterrySerial: this.data.butterrySerial
          ? this.data.butterrySerial
          : "",
        emergencyLevel: this.data.emergencyLevel
          ? this.data.emergencyLevel
          : "",
        signature: this.isCreated ? this.data.signature : "",
        alternativeWriting: this.data.alternativeWriting
          ? this.data.alternativeWriting
          : false,
        alternativeWritingReason: this.data.alternativeWritingReason
          ? this.data.alternativeWritingReason
          : "",
        isCreated: this.isCreated
      };
      // 新規作成時は「同意書作成日時」「シリアル交換日」を設定する
      // ANPY緊急連絡先の設定
      var cnt = 1;
      for (var i = 0; i < this.data.tels.length; i++) {
        if (
          this.data.tels[i].emergencyContactlList != null &&
          this.data.tels[i].emergencyContactlList != ""
        ) {
          var relationship = "relationship" + String(cnt);
          var relationshipFree = "relationshipFree" + String(cnt);
          var relationshipPhoneNumber = "relationshipPhoneNumber" + String(cnt);
          var relationshipCallFlag = "relationshipCallFlag" + String(cnt);
          setData[relationship] = this.data.tels[i].emergencyContactlList;
          setData[relationshipFree] = this.data.tels[i].emergencyContactFree
            ? this.data.tels[i].emergencyContactFree
            : "";
          setData[relationshipPhoneNumber] = this.data.tels[
            i
          ].emergencyContactPhoneNumber;
          setData[relationshipCallFlag] =
            this.data.tels[i].selfArrow == "0" ? true : false;
          cnt = cnt + 1;
        }
      }
      if (cnt != 11) {
        for (cnt; cnt != 11; cnt++) {
          var relationship = "relationship" + String(cnt);
          var relationshipFree = "relationshipFree" + String(cnt);
          var relationshipPhoneNumber = "relationshipPhoneNumber" + String(cnt);
          var relationshipCallFlag = "relationshipCallFlag" + String(cnt);
          setData[relationship] = null;
          setData[relationshipFree] = null;
          setData[relationshipPhoneNumber] = null;
          setData[relationshipCallFlag] = null;
        }
      }
      return client.apis.apiPatient.setEnterConsentInfoPOST({
        body: setData
      });
    },
    setEnterConsentInfoPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.back();
    },
    setEnterConsentInfoPOSTError: function(result) {
      this.showErrorMessage(result);
    },
    deleteData: function(event) {
      var excuteApi = this.deleteConsentInfoPOST;
      var successCallBack = this.deleteConsentInfoPOSTSuccess;
      var errorCallBack = this.deleteConsentInfoPOSTError;
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    deleteConsentInfoPOST: function(client) {
      return client.apis.apiPatient.deleteConsentInfoPOST({
        body: {
          id: this.id
        }
      });
    },
    deleteConsentInfoPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.back();
    },
    deleteConsentInfoPOSTError: function(result) {
      this.showErrorMessage(result);
    },
    addTels: function() {
      // ANPY緊急連絡先追加(最大10)
      if (this.data.tels.length < 10) {
        this.data.tels.push({});
      } else {
        this.showErrorMessage("連絡先は10件までしか登録できません。");
      }
    },
    back: function(event) {
      // 遷移元画面への遷移処理
      this.$router.push({
        name: this.prevRoute,
        params: { searchConditions: this.srcSearchConditions }
      });
    },
    getFieldName: function(str, index) {
      return str + index;
    },
    scan: function(itemCode, serial, type) {
      //カメラ呼び出し関数
      if (
        navigator.platform == "iPad" || // -iOS12
        (navigator.platform == "MacIntel" && // iPadOS
          navigator.userAgent.indexOf("Safari") != -1 &&
          navigator.userAgent.indexOf("Chrome") == -1 &&
          navigator.standalone !== undefined) ||
        navigator.userAgent == "AppGuardian"
      ) {
        // iPad
        // さらにWebKit判定を仕込む(UserAgentがAppGuardian)
        if (navigator.userAgent.endsWith("AppGuardian")) {
          // WkWebViewのためiPadアプリ
          // WkWebViewでのカメラアクセスを開始
          // コールバック関数を準備する
          // バーコード読み取り
          this.serialReaderByNative().then(
            function(returnValue) {
              var array = returnValue.split("/");
              if (array[1].length > 18) {
                this.showError();
              } else {
                // 本来はここでchildFunctionを呼び出すべきだが、Promiseのコールバックで
                // thisは使えないので直接ロジックを実行する
                switch (type) {
                  case 0:
                    this.data.itemCode = array[0];
                    this.data.serial = array[1];
                    break;
                  case 1:
                    this.data.butterryItemCode = array[0];
                    this.data.butterrySerial = array[1];
                    break;
                }
                return;
              }
            }.bind(this)
          );
          return;
        } else {
          // alert("使用可能な環境ではありません。PCブラウザまたはiPadアプリを使用してください。")
          // return;
        }
      } else {
        this.isSerialPuroductReaderModalActive = true;
        this.scanItemCode = itemCode;
        this.scanSerial = serial;
        this.scanType = type;
      }
    },
    showError: function() {
      this.showErrorMessage("19文字以上の「シリアル番号」は登録出来ません。");
    },
    serialReaderByNative: function() {
      // カメラアクセス/読取
      var promise = new Promise(function(resolve, reject) {
        // we generate a unique id to reference the promise later
        // from native function
        var promiseId = generateUUID();
        // save reference to promise in the global variable
        nativePromises[promiseId] = { resolve, reject };

        try {
          // call native function
          window.webkit.messageHandlers.callbackHandler.postMessage({
            promiseId: promiseId
          });
        } catch (exception) {
          alert("カメラアクセスでエラーが発生しました");
        }
      });
      return promise;
    },
    getOfficeName: function(value, officeMaster) {
      // 営業所名取得処理
      var officeElement = officeMaster.find(v => v.officeCode === value);
      if (officeElement) {
        return officeElement.officeName;
      }
      return "";
    },
    serialChanged: function(code, serial, type) {
      // 品目コード、シリアル設定処理
      if (type == 0) {
        this.data.itemCode = code;
        this.data.serial = serial;
        this.$validator.errors.remove("itemCode");
      } else if (type == 1) {
        this.data.butterryItemCode = code;
        this.data.butterrySerial = serial;
        this.$validator.errors.remove("butterryItemCode");
      }
    },
    inputValue: function(value, index) {
      if (value != "その他") {
        this.data.tels[index].emergencyContactFree = "";
      }
    },
    clearRecipient() {
      this.data.recipientCode = "";
      this.data.recipientName = "";
      this.isTemporaryRecipientCode = false;
    },
    getConsentCreateAt(signature) {
      if (signature) {
        return this.consentCreatAt;
      } else {
        return "同意書なし(患者情報管理から登録)";
      }
    },
    deleteRecipientConfirm() {
      this.$dialog.confirm({
        title: "ANPY同意書登録確認",
        message:
          "ANPY削除連携済みの患者が選択されています。<br/>ANPY同意書を再取得して問題ないでしょうか？",
        confirmText: "OK",
        cancelText: "キャンセル",
        type: "is-info",
        hasIcon: true,
        onConfirm: () => {
          var excuteApi = this.setEnterConsentInfoPOST;
          var successCallBack = this.setEnterConsentInfoPOSTSuccess;
          var errorCallBack = this.setEnterConsentInfoPOSTError;
          this.apiCall(excuteApi, successCallBack, errorCallBack);
        }
      });
    }
  },
  data() {
    // ログインユーザ情報取得
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    // 品目マスタ取得
    var productMaster = [];
    this.getProductList(productMaster);
    // 営業所マスタ取得
    var officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));

    // 遷移元画面のパラメータ取得
    var srcSearchConditions = this.$route.params["searchs"];
    var code = this.$route.params["code"];
    var isCreated = this.$route.params["isCreated"];
    var consentInfo = this.$route.params["consentInfo"];
    var subConsentInfo = this.$route.params["subConsentInfo"];

    // 遷移元画面のURL取得
    var prevRoute;
    if (code) {
      prevRoute = this.$route.params["prevRoutePath"].split("/");
      prevRoute = prevRoute[prevRoute.length - 2];
    } else {
      prevRoute = this.$route.params["prevRoutePath"].split("/");
      prevRoute = prevRoute[prevRoute.length - 1];
    }
    // 仮患者コードチェック用フラグ
    var isTemporaryRecipientCode = false;
    var data = {
      anpyFlag: false,
      recipientCode: "",
      recipientName: "",
      recipientNameKana: "",
      recipientNameMemo: "",
      tels: [],
      staffId: null,
      staffName: "",
      salesOfficeCode: "",
      senderSalesOfficeCode: "",
      officeName: "",
      itemCode: "",
      serial: "",
      butterryItemCode: "",
      butterrySerial: "",
      signature: "",
      alternativeWriting: null,
      alternativeWritingReason: "",
      machineReplaceProductCode: "",
      machineReplaceSerialNumber: "",
      emergencyLevel: ""
    };
    var id;
    var consentCreatAt = null;
    if (consentInfo && consentInfo.id) {
      // 患者情報が既に存在する場合、取得
      id = consentInfo.id;
      consentCreatAt = consentInfo.consentCreatAt;
      data.recipientCode = consentInfo.recipientCode;
      // 仮患者コード判定
      isTemporaryRecipientCode =
        consentInfo.recipientCode.indexOf("Z") != -1 ? true : false;
      data.anpyFlag = consentInfo.anpyFlag;
      data.recipientName = consentInfo.recipientName;
      data.recipientNameKana = consentInfo.recipientNameKana;
      data.recipientNameMemo = consentInfo.recipientNameMemo;
      data.salesOfficeCode = consentInfo.salesOfficeCode;
      data.senderSalesOfficeCode = consentInfo.senderSalesOfficeCode;
      data.staffId = consentInfo.consentCreatAt
        ? consentInfo.staffId
        : userInfo.id;
      data.staffName = consentInfo.consentCreatAt
        ? consentInfo.staffName
        : userInfo.fullName;
      data.officeCode = consentInfo.consentCreatAt
        ? consentInfo.officeCode
        : userInfo.officeCode;
      data.officeName = consentInfo.officeName
        ? consentInfo.officeName
        : this.getOfficeName(data.officeCode, officeMaster);
      data.itemCode = consentInfo.itemCode;
      data.serial = consentInfo.serial;
      data.butterryItemCode = consentInfo.butterryItemCode;
      data.butterrySerial = consentInfo.butterrySerial;
      data.signature = consentInfo.signature;
      data.alternativeWriting = consentInfo.alternativeWriting;
      data.alternativeWritingReason = consentInfo.alternativeWritingReason;
      data.machineReplaceProductCode = consentInfo.machineReplaceProductCode;
      data.machineReplaceSerialNumber = consentInfo.machineReplaceSerialNumber;
      data.emergencyLevel = consentInfo.emergencyLevel;
      for (var i = 1; i < 11; i++) {
        var relationship = "relationship" + String(i);
        var relationshipFree = "relationshipFree" + String(i);
        var relationshipPhoneNumber = "relationshipPhoneNumber" + String(i);
        var relationshipCallFlag = "relationshipCallFlag" + String(i);
        if (consentInfo[relationship]) {
          data.tels.push({
            emergencyContactlList: consentInfo[relationship],
            emergencyContactFree: consentInfo[relationshipFree],
            emergencyContactPhoneNumber: consentInfo[relationshipPhoneNumber],
            selfArrow: consentInfo[relationshipCallFlag] ? "0" : "1"
          });
        }
      }
      if (data.tels.length < 5) {
        var cnt = 5 - data.tels.length;
        for (var j = 0; j < cnt; j++) {
          data.tels.push({});
        }
      }
    } else {
      // 患者情報が存在しない場合、初期値設定
      data.staffId = userInfo.id;
      data.staffName = userInfo.fullName;
      data.officeCode = userInfo.officeCode;
      data.officeName = this.getOfficeName(userInfo.officeCode, officeMaster);
      data.senderSalesOfficeCode = userInfo.officeCode;
      for (var i = 0; i < 5; i++) {
        data.tels.push({});
      }
      if (subConsentInfo) {
        // 遷移元に患者情報が存在する場合
        data.recipientCode = subConsentInfo.recipientCode;

        // 仮患者コード判定
        isTemporaryRecipientCode =
          subConsentInfo.recipientCode.indexOf("Z") != -1 ? true : false;

        data.recipientName = subConsentInfo.recipientName;
        data.itemCode = subConsentInfo.itemCode;
        data.serial = subConsentInfo.serial;
        data.butterryItemCode = subConsentInfo.butterryItemCode;
        data.butterrySerial = subConsentInfo.butterrySerial;
      }
    }
    return {
      id,
      data,
      productMaster,
      prevRoute,
      code,
      isCreated,
      isSelectPatientActive: false,
      isSupportStaffChangeActive: false,
      isComponentModalActive: false,
      srcSearchConditions,
      isSerialPuroductReaderModalActive: false,
      scanItemCode: "",
      scanSerial: "",
      scanType: "",
      isTemporaryRecipientCode,
      roleId,
      consentCreatAt,
      officeMaster,
      recipientOfficeCodes: [],
      consentFormDeleteTarget: false
    };
  },
  filters: {
    productNameFilter: function(value, productMaster) {
      // 品目名フィルタ(品目コード⇒品目名)
      var element = productMaster.find(v => v.productCode === value);
      if (element) {
        return element.productName;
      }
      return "";
    },
    selfArrowFilter: function(value) {
      switch (value) {
        case "0":
          return "希望";
          break;
        case "1":
          return "希望しない";
          break;
        default:
          return "";
          break;
      }
      if (element) {
        return element.productName;
      }
      return "";
    }
  },
  components: {
    "staffChange-modal": ModalForm,
    "selectPatient-form": SelectPatientForm,
    "sign-modal": SignTemplate,
    "serialProductReader-modal": serialProductScannerTemplate
  },
  mounted: function() {},
  watch: {}
};
</script>



// WEBPACK FOOTER //
// src/components/AppPatientManagementEditConsentForm.vue